<template>
  <c-modal
    :width="340"
    title=""
    class="c-blogPostIeAlert"
    :active="isVisible"
    @close="$emit('close')"
  >
    <a
      class="c-blogPostIeAlert_close"
      href="javascript:;"
      @click="$emit('close')"
    >
      <coconala-icon
        name="cross"
        size="12px"
      />
    </a>
    <div class="c-blogPostIeAlert_text">
      InternetExplorerでは投稿機能はご利用できません。<br>
      PC版のGoogleChrome/MicrosoftEdge/MozillaFirefox/Safariよりご利用ください。
    </div>
    <div slot="footer">
      <c-button-v2
        width="156px"
        color="thirdly"
        size="m"
        @click="$emit('close')"
      >閉じる</c-button-v2>
    </div>
  </c-modal>
</template>
<script>
export default {
  name: 'BlogPostIeAlert',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
a,
button {
  @include link-effect;
}

.c-blogPostIeAlert {
  /deep/ .c-modal {
    &_footer {
      text-align: center;
    }
  }

  &_close {
    display: block;
    text-align: right;

    i {
      color: $color-black;
    }
  }

  &_text {
    font-weight: bold;
    margin-top: 8px;
  }
}
</style>
